<div mat-dialog-title class="mat-dialog-title">
  <span *ngIf="data?.action==='add'">{{'addnewtemplateDialog.createnewTemplate' | translate}}</span>
  <span *ngIf="data?.action==='clone'">{{'addnewtemplateDialog.cloneTemplate' | translate}}</span>
  <span *ngIf="data?.action==='edit'">{{'addnewtemplateDialog.editTemplate' | translate}}</span>
</div>

<div mat-dialog-content class="mat-dialog-title">
  <form [formGroup]="addTemplateForm" class="full-width">
    <mat-form-field class="full-width">
      <mat-label> {{'addnewtemplateDialog.templateName' | translate}} </mat-label>
      <input matInput formControlName="templateName">
    </mat-form-field>
    <mat-form-field class="full-width" *ngIf="!isVisol">
      <mat-label>{{'addnewtemplateDialog.reportType' | translate}}</mat-label>
      <mat-select formControlName="reportType">
        <mat-option *ngFor="let report of reportTypes" [value]="report.value">
          <span>{{ 'objects.' + report.label | translate }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="full-width" *ngIf="(addTemplateForm.value.reportType && (addTemplateForm.value.reportType === 'UTInspection' || addTemplateForm.value.reportType === 'VTInspection')) && !isVisol">
      <mat-label>{{'addnewtemplateDialog.equipmentType' | translate}}</mat-label>
      <mat-select formControlName="equipmentType" multiple>
        <mat-option *ngFor="let equipment of equipmentTypes" [value]="equipment.value">
          <span>{{ equipment.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>

</div>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeModal()">{{'addnewtemplateDialog.cancel' | translate}}</button>
  <button mat-flat-button color="primary" (click)="data?.action==='edit' ? updateTemplate(): createNewTemplate()" [disabled]="addTemplateForm.invalid">
    <span *ngIf="data?.action==='add'">{{'addnewtemplateDialog.create' | translate}}</span>
    <span *ngIf="data?.action==='clone'">{{'addnewtemplateDialog.clone' | translate}}</span>
    <span *ngIf="data?.action==='edit'">{{'addnewtemplateDialog.save' | translate}}</span>
  </button>
</mat-dialog-actions>
